export default document.getElementsByName('csrfmiddlewaretoken')[0].value